(() => {
  function initialise(root) {
    if (root.dataset.quickAddReady) return;
    root.dataset.quickAddReady = 'true';
    root.querySelectorAll('.inf-best__form, [data-quick-add-form]').forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const button = form.querySelector('[type="submit"]');
        if (button.disabled) return;
        const error = form.parentElement.querySelector('.inf-best__error, [data-quick-add-error]');
        error.hidden = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.classList.add('loading');
        let added = false;
        const cart = document.querySelector('cart-notification, cart-drawer');
        const sections = typeof cart?.getSectionsToRender === 'function' ? cart.getSectionsToRender() : [];
        const body = new FormData(form);
        if (sections.length) {
          body.append('sections', sections.map((section) => section.id).join(','));
          body.append('sections_url', window.location.pathname);
          cart.setActiveElement?.(button);
        }
        try {
          const response = await fetch(form.action + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body });
          const state = await response.json();
          if (!response.ok || state.status || state.errors) throw new Error(state.description || root.dataset.addError);
          added = true;
          if (!sections.length || typeof cart?.open !== 'function') {
            window.location.assign(window.routes?.cart_url || '/cart');
            return;
          }
          for (const section of sections) {
            const target = document.getElementById(section.id);
            const html = state.sections?.[section.id];
            if (!target || !html) throw new Error(root.dataset.addError);
            const contents = new DOMParser().parseFromString(html, 'text/html').querySelector('#minicart-form');
            if (!contents) throw new Error(root.dataset.addError);
            target.innerHTML = contents.innerHTML;
          }
          cart.cartAction?.();
          cart.classList.remove('is-empty');
          cart.open();
          const cartResponse = await fetch((window.routes?.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } });
          if (cartResponse.ok) {
            const summary = await cartResponse.json();
            document.querySelectorAll('.cart-count').forEach((count) => {
              count.textContent = count.classList.contains('cart-count-drawer') ? `(${summary.item_count})` : String(summary.item_count);
            });
            document.querySelector('header-total-price')?.updateTotal?.(summary);
            document.querySelector('free-ship-progress-bar')?.init?.(summary.items_subtotal_price);
          }
        } catch (failure) {
          if (added) {
            window.location.assign(window.routes?.cart_url || '/cart');
          } else {
            error.querySelector('.product-form__error-message').textContent = failure.message || root.dataset.addError;
            error.hidden = false;
          }
        } finally {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.classList.remove('loading');
        }
      });
    });
  }
  function initialiseSections(scope) {
    scope.querySelectorAll('[data-best-sellers], [data-collection-quick-add]').forEach(initialise);
  }
  initialiseSections(document);
  document.addEventListener('shopify:section:load', (event) => initialiseSections(event.target));
})();
